import React, { useCallback, useEffect, useState, Suspense } from "react";
import { useFormik } from "formik";
import { VscReplace } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import { FaTrash } from "react-icons/fa";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import HtmlEditor from "../../../components/UI/HtmlEditorInput/HtmlEditor";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import SelectFileInput from "../../../components/UI/SelectFileInput/SelectFileInput";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import { signalrActions } from "../../../redux/signalr";
import useSetGuard from "../../../hooks/useSetGuard";
import useAnexosParteServico from "./hooks/useAnexosParteServico";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import ButtonImagePermission from "../../../components/UI/Button/ButtonImagePermission";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import ReplaceChar from "../../../components/Formatters/ReplaceChar";
const TableContribuinteParteServico = React.lazy(() => import("./TableContribuinteParteServico"));
const SelectInputParteServicoFormik = React.lazy(() =>
  import("../../../components/UI/SelectInput/SelectInputParteServicoFormik"),
);
const SelectInputCachedFormik = React.lazy(() => import("../../../components/UI/SelectInput/SelectInputCachedFormik"));

const validationSchema = Yup.object().shape({
  sqParteServico: Yup.string().default(),
  sqTipoParteServico: Yup.string().default("").required("Escolha um Tipo de Parte de Serviço"),
  sqTipoInaptidao: Yup.string()
    .default("")
    .test("sqTipoParteServico", "Escolha um tipo de inaptidão", (values, initialValues) => {
      if (initialValues.parent.sqTipoParteServico !== "5" || (values || []).length > 0) {
        return true;
      }
      return false;
    }),
  sqOrgaoDestino: Yup.string().default("").required("Escolha um setor de destino"),
  txTextoPadrao: Yup.string().ensure().default("").required("Informe o Texto de Parte de Serviço"),
  anexos: Yup.array().max(3, "No máximo 3 anexos podem ser submetidos. "),
  contribuinte: Yup.array().required().min(1, "Escolha um Contribuinte"),
  isAssinar: Yup.boolean(),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  if (key === "contribuinte" || key === "anexos") {
    initialValues[key] = [];
  } else if (key === "isAssinar") {
    initialValues[key] = false;
  } else {
    initialValues[key] = "";
  }
});

const FormParteServico = ({ documento, history, location }) => {
  const { state } = location;
  const [inputContribuinte, setinputContribuinte] = useState("");
  const [dataListaContribuinte, setdataListaContribuinte] = useState([]);
  const [isListaContribuinte, setIsListaContribuinte] = useState(false);
  const [erroContribuinte, setErroContribuinte] = useState("");
  const [siglaOrgao, setSiglaOrgao] = useState("");
  const [showTextoParteServico, setShowTextoParteServico] = useState(false);
  const [showModalParteServico, setShowModalParteServico] = useState({
    show: false,
    body: null,
    context: null,
  });

  const setGuardClient = useSetGuard();

  const { filaAssinaturaSucessoStateKey, filaAssinaturaFalhaStateKey } =
    useSelector((stateSignalr) => stateSignalr.signalr) || {};

  const dispatch = useDispatch();

  const { request: requestSafePayload, data: dataSafePayload } = useApiClient();
  const { request: requestForm, data: dataForm, errors: errorForm, isLoading } = useApiClient();
  const { request: requestAnexo, data: dataAnexo } = useApiClient();
  const [anexosPS, setAnexosPS] = useState([]);

  const { excluirAnexo } = useAnexosParteServico();

  const handleSubmit = useCallback(
    (values) => {
      if (values.sqParteServico) {
        requestForm(apiRoutes.fiscalizacao.parteservico.alterarParteServico, values);
      } else requestForm(apiRoutes.fiscalizacao.parteservico.inserirParteServico, values);
    },
    [requestForm],
  );

  const handleSafePayload = useCallback(() => {
    requestSafePayload(apiRoutes.usuarios.arquivo.selecionar, dataForm?.result);
  }, [requestSafePayload, dataForm]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const {
    handleChange,
    setSubmitting,
    setErrors,
    isSubmitting,
    isValid,
    errors,
    touched,
    setValues,
    setFieldValue,
    values,
  } = formik;

  const { push } = history;

  useEffect(() => {
    if ((dataForm || errorForm) && isSubmitting && !isLoading) setSubmitting(false);

    if (errorForm && isValid && !isLoading) setErrors({ ...errors, ...errorForm });

    if (errorForm) {
      toast.error(errorForm.message);
    }

    if (dataForm) {
      toast.success(dataForm.result);

      if (values.isAssinar) {
        handleSafePayload();
      }

      push("/app/parteservico");
    }

    if (errorForm) {
      toast.error(errorForm.message);
    }
  }, [
    handleSafePayload,
    setSubmitting,
    setErrors,
    push,
    errors,
    isSubmitting,
    isValid,
    dataForm,
    errorForm,
    isLoading,
    values.isAssinar,
  ]);

  // Carregar item
  const {
    request: parteServicoRequest,
    data: parteServicoData,
    errors: parteServicoErrors,
    isLoading: parteServicoLoading,
  } = useApiClient();

  useEffect(() => {
    if (state && state.sqParteServico) {
      parteServicoRequest(apiRoutes.fiscalizacao.parteservico.listaParteServicoPv, { id: state.sqParteServico });
      requestAnexo(apiRoutes.fiscalizacao.parteservico.anexosParteServico, { sqParteServico: state.sqParteServico });
      delete state.itemKey;
    }
  }, [parteServicoRequest, state, requestAnexo]);

  // Editar
  useEffect(() => {
    if ((!parteServicoData && !parteServicoErrors) || parteServicoLoading) return;

    if (parteServicoData) {
      const item = parteServicoData?.result[0];

      setValues({
        ...item,
        sqTipoParteServico: item?.sqTipoParteServico?.toString() || "",
        sqTipoInaptidao: item?.sqTipoInaptidao?.toString() || "",
        anexos: [],
        isAssinar: false,
      });

      // FORÇA O SELECT A SINCRONIZAR
      setTimeout(() => {
        setFieldValue("sqTipoInaptidao", item?.sqTipoInaptidao?.toString() || "");
      }, 0);
    }
    if (dataAnexo) {
      setAnexosPS(dataAnexo?.result);
    }

    if (parteServicoErrors) {
      toast.error(parteServicoErrors.message);
    }
  }, [setValues, setFieldValue, parteServicoData, parteServicoErrors, parteServicoLoading, dataAnexo]);

  const {
    request: requestContribuinte,
    data: dataContribuinte,
    errors: errorContribuinte,
    isLoading: loadContribuinte,
  } = useApiClient();

  const consultaContribuinte = useCallback(
    (identificador) => {
      const params = { listaContribuinte: identificador };
      requestContribuinte(apiRoutes.fiscalizacao.procedimentoFiscal.consultaContribuinte, params);
    },
    [requestContribuinte],
  );

  useEffect(() => {
    const contribuinte = parteServicoData?.result[0];
    if (contribuinte?.nuIE) {
      consultaContribuinte(contribuinte?.nuIE);
    } else if (contribuinte?.nuCNPJ) {
      consultaContribuinte(contribuinte?.nuCNPJ);
    }
  }, [parteServicoData, consultaContribuinte]);

  useEffect(() => {
    if (dataContribuinte && !loadContribuinte) {
      if (dataContribuinte.result.encontrados.length > 0) {
        dataContribuinte.result.encontrados.forEach((item) => {
          if (
            !dataListaContribuinte.find(
              (x) =>
                x.sequencialPessoa === item.sequencialPessoa &&
                x.sequencialContribuinte === item.sequencialContribuinte,
            )
          ) {
            setdataListaContribuinte(dataContribuinte.result.encontrados);
          }
        });
      }
      if (dataContribuinte.result.encontrados.length > 0) {
        setIsListaContribuinte(true);
        setSiglaOrgao(dataContribuinte.result.encontrados[0]?.siglaOrgao);
      } else {
        setIsListaContribuinte(false);
        setSiglaOrgao("");
      }

      if (dataContribuinte.result.naoEncontrados.length > 0) {
        setErroContribuinte(
          `Documentos não encontrados em nossa base de dados: ${dataContribuinte.result.naoEncontrados}`,
        );
      } else {
        setErroContribuinte("");
      }
    }
    if (errorContribuinte && !loadContribuinte) {
      setErroContribuinte("");
    }
  }, [dataContribuinte, errorContribuinte, loadContribuinte, dataListaContribuinte]);

  useEffect(() => {
    if (documento && documento !== undefined) {
      consultaContribuinte(documento);
    }
  }, [documento, consultaContribuinte]);

  const {
    request: requestTextoParteServico,
    data: dataTextoParteServico,
    // isLoading: loadTextoParteServico,
  } = useApiClient();

  useEffect(() => {
    if (isListaContribuinte && !values.sqOrgaoDestino) {
      setFieldValue("sqOrgaoDestino", "12");
    }
  }, [isListaContribuinte, values.sqOrgaoDestino, setFieldValue]);

  // const regrasTipoPS = {
  //   5: () => (siglaOrgao === "6 URT" ? 9 : 12),
  //   Q: () => (siglaOrgao === "6 URT" ? 9 : 12),
  //   C: () => 12,
  //   D: () => 12,
  // };

  useEffect(() => {
    if (!values.sqTipoParteServico || values.sqParteServico) return;

    if (values.sqTipoParteServico === "5") {
      if (isListaContribuinte) {
        setValues((obj) => ({
          ...obj,
          sqOrgaoDestino: siglaOrgao === "6 URT" ? 9 : 12,
        }));
      }

      setFieldValue("sqTipoInaptidao", "0");
    }
  }, [values.sqTipoParteServico, isListaContribuinte, siglaOrgao, values.sqParteServico, setValues, setFieldValue]);

  useEffect(() => {
    if (!values.sqTipoParteServico || values.sqParteServico) return;

    if (values.sqTipoParteServico !== "5") {
      setFieldValue("sqTipoInaptidao", "");
    }
  }, [values.sqTipoParteServico, setFieldValue, values.sqParteServico]);

  const resetForm = () => {
    formik.resetForm();
  };

  // Assinatura de PARTE DE SERVIÇO
  const assinaturaHandler = useCallback(
    (safePayload) => {
      setGuardClient.assinar(safePayload);
    },
    [setGuardClient],
  );

  useEffect(() => {
    if (dataSafePayload) {
      assinaturaHandler(dataSafePayload.result);
    }
  }, [dataSafePayload, assinaturaHandler]);

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      toast.success("Assinatura concluída com sucesso. ", { toastId: filaAssinaturaSucessoStateKey });
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
    };
  }, [dispatch, filaAssinaturaSucessoStateKey, dataForm?.result, history]);

  useEffect(() => {
    if (filaAssinaturaFalhaStateKey) {
      toast.error("Assinatura concluída com erros. ", { toastId: filaAssinaturaFalhaStateKey });
    }
    return () => {
      dispatch(signalrActions.clearState(filaAssinaturaFalhaStateKey));
    };
  }, [dispatch, filaAssinaturaFalhaStateKey, history]);

  const buscaTextoParteServico = (params) => {
    requestTextoParteServico(apiRoutes.fiscalizacao.parteservico.getTextoParteServico, params);
  };

  useEffect(() => {
    if (values.sqParteServico) return; // edição NÃO sobrescreve

    if (dataTextoParteServico?.result?.[0]?.txTextoPadrao) {
      setFieldValue("txTextoPadrao", ReplaceChar(dataTextoParteServico.result[0].txTextoPadrao));

      setShowTextoParteServico(true);
    }
  }, [dataTextoParteServico, values.sqParteServico, setFieldValue]);

  useEffect(() => {
    if (!values.sqTipoInaptidao || values.sqParteServico) return;

    setFieldValue("txTextoPadrao", "");
  }, [values.sqTipoInaptidao, values.sqParteServico, setFieldValue]);

  const handleCustomChange = (e) => {
    const sqTipoInaptidao = e.target.value;

    // Atualiza Formik primeiro
    setFieldValue("sqTipoInaptidao", sqTipoInaptidao);

    const params = {
      id: values.sqTipoParteServico,
      sqTipoInaptidao,
      sqTipoParteServico: values.sqTipoParteServico,
      pageSize: 10,
      pageNumber: 1,
    };

    buscaTextoParteServico(params);
  };

  const handleChangeTipoPS = (e) => {
    // I	Notas Fiscais - Operações Interestaduais
    // E	Notas Fiscais - Operações Internas.
    // N	Outros
    // C	Credenciamento NFE-MEI
    // A	Inaptidão de IE
    // Q	Apreensão de Equipamentos

    handleChange(e);

    const selectedOption = e?.target.options[e?.target.selectedIndex];
    const keyValue = selectedOption.getAttribute("data-key");

    const params = {
      id: null,
      sqTipoInaptidao: 0,
      sqTipoParteServico: keyValue === "A" ? 0 : e.target.value,
      pageSize: 10,
      pageNumber: 1,
    };

    buscaTextoParteServico(params);
  };

  return (
    <>
      <EfisModal
        show={showModalParteServico.show}
        body={showModalParteServico.body}
        title="Texto da Parte de Serviço"
        size="lg"
        closeHandler={() => setShowModalParteServico({ show: false })}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
      />
      <h1 className="h3 mb-4 text-gray-800">Parte de Serviço</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="11">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">
                    {values.sqParteServico ? "Alterar Parte de Serviço - Nº " : "Nova Parte de Serviço"}
                    {values.sqParteServico ? values.sqParteServico : ""}
                  </h6>
                </Col>
              </Row>
            </div>
            <div className="card-body">
              <Row className="mx-0 mb-3">
                <Form.Control
                  type="text"
                  onChange={(event) => setinputContribuinte(event.target.value)}
                  placeholder="Informe um IE/CNPJ"
                  id="listaContribuinteInput"
                  className="col-md-6"
                  field="contribuinte"
                  disabled={values.txStParteServico === "A" || values.txStParteServico === "S"}
                  isInvalid={touched.contribuinte && errors.contribuinte}
                />
                {loadContribuinte ? (
                  <TextSpinner text="Buscando contribuinte..." />
                ) : (
                  <Button
                    disabled={values.txStParteServico === "A" || values.txStParteServico === "S"}
                    onClick={() => consultaContribuinte(inputContribuinte)}
                    className="mx-2"
                  >
                    Buscar
                  </Button>
                )}
                {touched.contribuinte && errors.contribuinte && (
                  <Form.Control.Feedback type="invalid">{errors.contribuinte}</Form.Control.Feedback>
                )}
              </Row>
              <FormAlert
                formik={formik}
                data={dataContribuinte}
                errors={errorContribuinte}
                isLoading={loadContribuinte}
              />
              <Row hidden={erroContribuinte === ""}>
                <Form.Group className="mb-3" as={Col} sm={12} md={12}>
                  <Alert variant="danger" className="text-center">
                    {erroContribuinte}
                  </Alert>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group className="mb-3" as={Col} sm={12} md={12}>
                  <Suspense fallback={<div>Carregando...</div>}>
                    <TableContribuinteParteServico data={dataListaContribuinte} formik={formik} field="contribuinte" />
                  </Suspense>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group className="mb-3" as={Col} sm={12} md={6}>
                  <Form.Label>Tipo de Parte de Serviço:</Form.Label>
                  <SelectInputCachedFormik
                    formik={formik}
                    field="sqTipoParteServico"
                    tipoItem="tipo-parte-servico-ativo"
                    disabled={!isListaContribuinte || values.txStParteServico === "A"}
                    onChange={handleChangeTipoPS}
                  />
                </Form.Group>
                <Form.Group className="mb-3" as={Col} sm={12} md={6}>
                  <Form.Label>Tipo de Inaptidão:</Form.Label>
                  <Suspense fallback={<div>Carregando...</div>}>
                    <SelectInputCachedFormik
                      formik={formik}
                      field="sqTipoInaptidao"
                      tipoItem="tipo-inaptidao"
                      disabled={values.sqTipoParteServico !== "5" || values.txStParteServico === "A"}
                      onChange={handleCustomChange}
                    />{" "}
                  </Suspense>
                </Form.Group>
                <Form.Group className="mb-3" as={Col} xs={12} md={12}>
                  <Form.Label>Setor Destino:</Form.Label>
                  <Suspense fallback={<div>Carregando...</div>}>
                    <SelectInputParteServicoFormik
                      formik={formik}
                      field="sqOrgaoDestino"
                      tipoItem="orgaos-geral"
                      disabled={!values.sqTipoParteServico}
                    />
                  </Suspense>
                </Form.Group>

                <Form.Group className="mb-3" as={Col} xs={12} md={12}>
                  <Form.Label>
                    <b> Texto da Parte de Serviço </b>
                    {formik.values.txStParteServico !== undefined ||
                      (formik.values.txStParteServico !== "A" && (
                        <BiEdit
                          className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                          title={showTextoParteServico ? "Editar Texto" : "Fechar Edição"}
                          onClick={() => {
                            setShowTextoParteServico(!showTextoParteServico);
                            // trocarTextoFormik();
                          }}
                        />
                      ))}
                    <VscReplace
                      className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                      title="Visualizar texto com substituições"
                      onClick={() =>
                        setShowModalParteServico({
                          show: true,
                          body: <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(values.txTextoPadrao) }} />,
                        })
                      }
                    />
                  </Form.Label>

                  <HtmlEditor
                    formik={formik}
                    field="txTextoPadrao"
                    rows="5"
                    disabled={values.txStParteServico === "A"}
                  />
                </Form.Group>
              </Row>

              <Row className="mb-5">
                <Form.Group className="mb-3" as={Col} xs={12}>
                  <Form.Label as={Row} className="ml-1 mb-2">
                    <b>Anexos</b>
                  </Form.Label>

                  {state?.origem !== "dossie" && <SelectFileInput field="anexos" formik={formik} multiple save />}

                  <div style={{ marginTop: 30 }}>
                    {anexosPS.map((arquivo) => (
                      <div style={{ display: "flex" }}>
                        <strong>{`- ${arquivo.txNome.toUpperCase()}`}</strong>
                        <FileDownloader
                          binario={arquivo.documento}
                          nomeArquivo={arquivo.txNome}
                          tooltip="Download Documento"
                        />
                        <ButtonImagePermission
                          permission={funcionalidades.parteServico.deletar}
                          className="btn-sm text-danger pa-0 p-0 px-1"
                          style={{ fontSize: "1rem" }}
                          onClick={() => excluirAnexo(arquivo.sqParteServico, arquivo.sqParteServicoAnexo)}
                          buttonImage={<FaTrash />}
                          tooltipImage={
                            formik.values.txStParteServico !== "S" ? "Anexo não pode ser excluído" : "Excluir Anexo"
                          }
                          disabled={formik.values.txStParteServico !== "S"}
                        />
                      </div>
                    ))}
                  </div>
                </Form.Group>
              </Row>
              <Row className="mt-2">
                <Col>
                  {formik.isSubmitting ? (
                    <TextSpinner text="Registrando Parte de Serviço..." />
                  ) : (
                    state?.origem !== "dossie" && (
                      <Button variant="primary" className="mr-3" size="md" onClick={formik.handleSubmit}>
                        Salvar
                      </Button>
                    )
                  )}
                  {state?.origem !== "dossie" && (
                    <Button
                      variant="light"
                      className="mr-3"
                      size="md"
                      disabled={values.txStParteServico === "A"}
                      onClick={() => resetForm()}
                    >
                      Limpar
                    </Button>
                  )}

                  {!formik.isSubmitting && (
                    <Button
                      variant="danger"
                      className="mr-3"
                      size="md"
                      onClick={() =>
                        history.push({
                          pathname: "/app/parteservico",
                          state: { paginatedViewState: location.state?.paginatedViewState }, // Transfere o estado correto
                        })
                      }
                    >
                      Voltar
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormParteServico;
